<template>
  <div
    class="group"
    :class="{
      'flex items-center justify-between gap-2': flex,
      '!gap-1': $slots.label || changed,
    }"
  >
    <t-label
      v-if="label && !$slots.label"
      :changed="changed"
      :tooltip="resetTooltip"
      @reset="$emit('reset')"
      >{{ label }}</t-label
    >
    <t-label
      v-if="$slots.label"
      v-tooltip="{
        content: label,
      }"
      :changed="changed"
      :tooltip="resetTooltip"
      @reset="$emit('reset')"
    >
      <slot name="label"></slot>
    </t-label>
    <div class="flex" role="tabpanel">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
import TLabel from "../TLabel/TLabel.vue";

defineProps<{
  label?: string;
  flex?: boolean;
  changed?: boolean;
  resetTooltip?: string;
}>();

defineEmits(["reset"]);
</script>
